<template>
  <div class="mt-4 px-5">
    <h2>Meine Pool-Beiträge</h2>

    <v-data-table
      :headers="headers"
      :items="comp_MyContributions"
      class="elevation-1 mt-4"
    >
      <template v-slot:top>
        <v-toolbar flat color="primary">
          <v-toolbar-title class="white--text">Meine Pool-Waffen</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="refreshData">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.weapon_info="{ item }">
        <div>
          <strong>{{ item.weapon.hersteller }} {{ item.weapon.kurz_bezeichnung }}</strong>
          <br>
          <span class="text-caption">{{ item.weapon.kaliber }}</span>
        </div>
      </template>

      <!-- NEU: Verein-Badge mit Nutzungsstatistik -->
      <template v-slot:item.club_info="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              small
              :color="item.is_active ? 'blue' : 'grey'"
              text-color="white"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small left>mdi-domain</v-icon>
              {{ item.club_name }}
            </v-chip>
          </template>
          <span>
            <strong>{{ item.club_name }}</strong><br />
            Gesamtnutzung: {{ item.usage_count || 0 }}x<br />
            Letzte 30 Tage: {{ item.usage_last_30_days || 0 }}x<br />
            Status: {{ item.is_active ? "Aktiv" : "Inaktiv" }}
          </span>
        </v-tooltip>
      </template>

      <template v-slot:item.created_at="{ item }">
        <span>{{
          new Date(item.created_at.replace(" ", "T")).toLocaleString([], {
            dateStyle: 'short',
            timeStyle: 'short'
          })
        }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          class="orange my-1"
          text
          @click="openEditDialog(item)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          class="error my-1"
          text
          @click="openDeleteDialog(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Edit Dialog -->
    <v-dialog v-model="dialogEdit" max-width="600px">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Hinweise bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogEdit = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-textarea
            v-model="editedNotes"
            label="Hinweise"
            outlined
            rows="4"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogEdit = false">
            Abbrechen
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveNotes">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">
          Waffe aus Pool entfernen?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false">
            Abbrechen
          </v-btn>
          <v-btn color="blue darken-1" text @click="confirmRemove">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "weaponpoolMine",
  data: () => ({
    dialogEdit: false,
    dialogDelete: false,
    selectedItem: null,
    editedNotes: '',
    headers: [
      { text: "Waffe", value: "weapon_info", sortable: false },

      // NEU: Verein mit Nutzung
      { text: "Verein", value: "club_info", sortable: false },

      { text: "Im Pool seit", value: "created_at", sortable: true },
      { text: "Hinweise", value: "notes", sortable: false },
      { text: "Aktionen", value: "actions", sortable: false, align: "center" }
    ]
  }),

  computed: {
    comp_MyContributions() {
      return this.$store.getters['UserApp/myPoolContributions'];
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      await this.$store.dispatch('UserApp/fetchMyPoolContributions');
    },
    refreshData() {
      this.loadData();
    },
    openEditDialog(item) {
      this.selectedItem = item;
      this.editedNotes = item.notes || '';
      this.dialogEdit = true;
    },
    async saveNotes() {
      await this.$store.dispatch('UserApp/updateWeaponPoolNotes', {
        weapon_pool_id: this.selectedItem.id,
        notes: this.editedNotes
      });
      this.dialogEdit = false;
    },
    openDeleteDialog(item) {
      this.selectedItem = item;
      this.dialogDelete = true;
    },
    async confirmRemove() {
      await this.$store.dispatch('UserApp/removeWeaponFromPool', this.selectedItem.id);
      this.dialogDelete = false;
    }
  }
}
</script>
